import { render, staticRenderFns } from "./PhoneView.vue?vue&type=template&id=5cd1b1b2&scoped=true"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"
import style0 from "./PhoneView.vue?vue&type=style&index=0&id=5cd1b1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1b1b2",
  null
  
)

export default component.exports